import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  updateCustomSurveyTemplate,
  type CreateCustomSurveyTemplateRequest,
  type CustomSurveyTemplate,
} from '../../api/customSurveyTemplates';
import { customSurveyTemplateKeys } from '../queries/queryKeys';

export const useUpdateCustomSurveyTemplateMutation = (options?: {
  onSuccess?: (data: CustomSurveyTemplate) => void;
  onError?: (error: Error) => void;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: number;
      data: CreateCustomSurveyTemplateRequest;
    }) => updateCustomSurveyTemplate(id, data),
    onSuccess: (data) => {
      // Invalidate the specific template and all lists
      queryClient.invalidateQueries({ queryKey: customSurveyTemplateKeys.detail(data.id) });
      queryClient.invalidateQueries({ queryKey: customSurveyTemplateKeys.lists() });
      options?.onSuccess?.(data);
    },
    onError: (error: Error) => {
      options?.onError?.(error);
    },
  });
};
